// @import_dependencies
import React, { FC, ReactElement } from 'react'
import { store } from 'app_storage/redux-storage'
// @end

// @import components
import {
  AdminDashboardHomeComponent,
  StudentDashboardHomeComponent,
  TeacherDashboardHomeComponent,
  DefaultHomeComponent,
  ExecutiveDashboardHomeComponent,
  CompanyDashboardHomeComponent
} from 'app_components/modules/homeScreens'
// @end

// @import services
import { routingService } from 'app_services/routingService'
import StudentDashboardPage from 'app_components/modules/homeScreens/StudentDashboardPage/StudentDashboardPage';
import StudentsAppLayout from 'app_components/layouts/app/components/StudentsAppLayout/StudentsAppLayout';
import { UserHome } from 'app_types/userTypes';
import { IAppState } from 'app_events/app/types';
// @end

// @import utilities
// @end

// @import types
interface IHomeProps {
  children: ReactElement
  app?: IAppState
}
// @end

class HomeService {

  private storeObject: any
  private auth: any

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.storeObject = store
    this.auth = this.storeObject?.getState().auth
  }

  public renderLayout = (props: IHomeProps, DefaultLayout: FC) => {
    const home = this.auth?.user?.data?.home?.name
    switch(home) {
      case UserHome.STUDENT:
        return <StudentsAppLayout {...props} />
      default:
        return <DefaultLayout {...props}/>
    }
  }

  public renderHome = (props?: any, history?: any): ReactElement => {
    if (this.auth && this.auth.user && this.auth.user.data && this.auth.user.data.home) {
      switch (this.auth.user.data.home.name) {
        case UserHome.ADMIN:
          return <AdminDashboardHomeComponent {...props} />
        case UserHome.STUDENT:
          return <StudentDashboardPage {...props} />
          // return <StudentDashboardHomeComponent {...props} />
        case UserHome.TEACHER:
          return <TeacherDashboardHomeComponent {...props} />
        case UserHome.ACCOUNT_EXECUTIVE:
          return <ExecutiveDashboardHomeComponent {...props} />
        case UserHome.COMPANY:
          return <CompanyDashboardHomeComponent {...props} />
        default:
          return <DefaultHomeComponent {...props} />
      }
    } else {
      return <DefaultHomeComponent {...props} />
    }
  }

}

export default HomeService
